'use strict'

import axios from 'axios'

const { VUE_APP_GATEWAY_URL } = process.env

export default async ({ jwt, userIds }) => {
  const { data } = await axios({
    method: 'post',
    url: `${VUE_APP_GATEWAY_URL}/idp/public-keys`,
    headers: { Authorization: jwt },
    timeout: 8000,
    data: userIds
  })

  return data
}
